import {
  SET_PICTURE_CLIENT_FB_LIST,
  SET_PICTURE_CLIENT_FB_PAGE_NUM,
  SET_PICTURE_CLIENT_FB_PAGE_SIZE,
  SET_PICTURE_CLIENT_FB_PAGE_SIZE_TOTAL,
  SET_PICTURE_CLIENT_FB_QUERY,
  SET_PICTURE_CLIENT_FB_SEARCHING,
} from './mutation-types.js'
import api from '@/api'
import _ from 'lodash'

const initQuery = () => ({
  pageSize: 20,
  pageNum: 1,
  userName: '',
  userId: '',
  type: '',
  module: '',
  errorTypes: [],
  status: '',
  version: '',
  startDate: new Date().getTime() - 3600 * 1000 * 24 * 7,
  endDate: new Date().setHours(23, 59, 59, 999),
  channel: 1, // 0：FOX动画版客户端，1：效果图客户端
})

const state = {
  searching: false,
  initQuery: initQuery(),
  pictureClientFeedback: {
    list: [],
    listPagTotal: 0,
    query: initQuery(),
  },
}

const mutations = {
  [SET_PICTURE_CLIENT_FB_LIST] (state, payload) {
    state.pictureClientFeedback.list = payload
  },
  [SET_PICTURE_CLIENT_FB_PAGE_NUM] (state, payload) {
    state.pictureClientFeedback.query.pageNum = payload
  },
  [SET_PICTURE_CLIENT_FB_PAGE_SIZE] (state, payload) {
    state.pictureClientFeedback.query.pageSize = payload
  },
  [SET_PICTURE_CLIENT_FB_PAGE_SIZE_TOTAL] (state, payload) {
    state.pictureClientFeedback.listPageTotal = payload
  },
  [SET_PICTURE_CLIENT_FB_QUERY] (state, payload) {
    state.pictureClientFeedback.query = {
      ...state.pictureClientFeedback.query,
      ...payload,
    }
  },
  [SET_PICTURE_CLIENT_FB_SEARCHING](state, payload) {
    state.searching = payload
  },
}

const actions = {
  async getPictureClientFb({commit, state}, payload) {
    try {
      commit(SET_PICTURE_CLIENT_FB_SEARCHING, true)
      let query = {}
      _.forIn(state.pictureClientFeedback.query, (v, k) => {
        if ((v instanceof Array && v.length > 0) || (v instanceof Array === false && v !== '')) {
          if (['type', 'module', 'status'].includes(k)) {
            query[k] = Number(v)
          } else {
            query[k] = v
          }
        }
      })
      let params = {
        ...query,
        ...payload,
      }
      let {data: {items, total}} = await api.userApi.queryUserFeedbackNew(params)
      commit(SET_PICTURE_CLIENT_FB_SEARCHING, false)
      commit(SET_PICTURE_CLIENT_FB_LIST, items)
      commit(SET_PICTURE_CLIENT_FB_PAGE_SIZE_TOTAL, total)
      return items
    } catch (error) {
      commit(SET_PICTURE_CLIENT_FB_SEARCHING, false)
      commit(SET_PICTURE_CLIENT_FB_PAGE_SIZE_TOTAL, 0)
      commit(SET_PICTURE_CLIENT_FB_LIST, [])
    }
  },
  setPitureClientFbQuery ({commit}, payload) {
    commit(SET_PICTURE_CLIENT_FB_QUERY, payload)
  },
  async initPictureClientFb ({dispatch}) {
    await dispatch('setPitureClientFbQuery', state.initQuery)
    await dispatch('getPictureClientFb')
  },
  // // 改变每页显示条数
  changePageSize ({commit, dispatch}, payload) {
    commit(SET_PICTURE_CLIENT_FB_PAGE_SIZE, payload.pageSize)
    commit(SET_PICTURE_CLIENT_FB_PAGE_NUM, 1)
  },
  setPageNum ({commit, dispatch}, payload) {
    commit(SET_PICTURE_CLIENT_FB_PAGE_NUM, payload.currentPage)
  },
  async queryFeedbackVersions({commit, dispatch}, payload) {
    const { code, data } = await api.userApi.queryFeedbackVersions({channel: 1})
    if (code === 200) {
      return data
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
